var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as cn from "classnames";
import * as React from "react";
import { Flyout } from "../../../../components/flyout";
import { Link } from "../link";
import * as styles from "./styles.css";
export var NavigationDesktop = function (_a) {
    var links = _a.links, profileLinks = _a.profileLinks, _b = _a.hasCart, hasCart = _b === void 0 ? false : _b, className = _a.className, rest = __rest(_a, ["links", "profileLinks", "hasCart", "className"]);
    return (React.createElement("nav", { className: cn(className), role: "navigation", "aria-label": "Main navigation" },
        React.createElement("ul", null,
            links.map(function (link) { return (React.createElement("li", { className: styles.navigationDesktopItem, key: link.text },
                React.createElement(Link.Navigation, { href: link.href, "data-section": link.text, topLevel: true }, link.text),
                link.items.length > 0 && (React.createElement(Flyout, { className: styles.navigationDesktopMenu },
                    React.createElement("ul", { className: styles.navigationDesktopMenuList }, link.items.map(function (sublink) { return (React.createElement("li", { key: sublink.text },
                        React.createElement(Link.Navigation, { className: styles.navigationDesktopMenuListLink, href: sublink.href }, sublink.text))); })),
                    link.callout &&
                        React.createElement("a", { className: cn(styles.navigationDesktopMenuCallout, styles.navigationDesktopMenuCalloutButton), href: link.callout.href }, link.callout.text))))); }),
            hasCart &&
                React.createElement("li", { className: cn(styles.navigationDesktopItem, styles.navigationDesktopItemCart), key: "Shopping cart" },
                    React.createElement(Link.Shop, { hasItems: true })),
            React.createElement("li", { className: cn(styles.navigationDesktopItem, styles.navigationDesktopItemAvatar), key: "Profile" },
                React.createElement(Link.Avatar, { href: "/profile", imageSrc: "https://community-media.lonelyplanet.com/users/avatars/" +
                        "c946fa97-b11f-4950-a43b-c41180c28cd7/large/" +
                        "YmxvYlR1ZSBPY3QgMTAgMjAxNyAxNjo0NTowMyBHTVQrMDAwMCAoVVRDKQ%3D%3D.jpg" }),
                React.createElement(Flyout, { className: styles.navigationDesktopMenu },
                    React.createElement("ul", { className: styles.navigationDesktopMenuList }, profileLinks.map(function (sublink) { return (React.createElement("li", { key: sublink.text },
                        React.createElement(Link.Navigation, { className: styles.navigationDesktopMenuListLink, href: sublink.href }, sublink.text))); })),
                    React.createElement(Link.Navigation, { className: cn(styles.navigationDesktopMenuCallout, styles.navigationDesktopMenuCalloutLink), href: "/" }, "Sign out"))))));
};



//////////////////
// WEBPACK FOOTER
// ./app/shared/patterns/global/header/navigation/navigationDesktop.tsx
// module id = yScR
// module chunks = 2